import React from "react";
import T from "i18n-react";
import { AlertStatusCard } from "../../../../yoello-lib/modules/components/UI/Alerts/AlertStatusCard";
import { ReactComponent as AlertErrorIcon } from "../../../../imges/AlertErrorIcon.svg";
import { ReactComponent as AlertSuccessIcon } from "../../../../imges/AlertSuccessIcon.svg";
import { postcodeCheckStatusType } from "../PostCodeChecker";

interface IPostCodeAlertProps {
  postcodeCheckStatus: postcodeCheckStatusType;
}

function PostCodeAlert({ postcodeCheckStatus }: IPostCodeAlertProps) {
  const renderAlert = () => {
    switch (postcodeCheckStatus) {
      case postcodeCheckStatusType.PostCodeInValid:
        return (
          <AlertStatusCard
            alertProps={{
              color: "error",
              icon: <AlertErrorIcon />,
              style: {
                color: "#F65164",
                borderRadius: "0.75rem",
                fontWeight: 600,
              },
            }}
            alertTitle={T.translate("Forms.InvalidPostcode")}
            alertMessage={T.translate("Forms.EnterValidPostCode")}
          />
        );

      case postcodeCheckStatusType.OutOfDeliveryRadius:
        return (
          <AlertStatusCard
            alertProps={{
              color: "error",
              icon: <AlertErrorIcon />,
              style: {
                color: "#F65164",
                borderRadius: "0.75rem",
                fontWeight: 600,
              },
            }}
            alertMessage={T.translate("Forms.OurOfDeliveryRadius")}
          />
        );

      case postcodeCheckStatusType.InDeliveryRadius:
        return (
          <AlertStatusCard
            alertProps={{
              color: "success",
              icon: <AlertSuccessIcon />,
              style: {
                color: "#24C277",
                borderRadius: "0.75rem",
              },
            }}
            alertTitle={T.translate("Forms.GreatNews")}
            alertMessage={T.translate("Forms.InDeliveryRadius")}
          />
        );

      default:
        break;
    }
  };

  return <div>{renderAlert()}</div>;
}

export default PostCodeAlert;
